'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$() {
  this.aII = null;
  this.aIE = null;
  this.aIF = false;
  this.aIG = null;
  this.aIH = false;
  this.aIy = null;
  this.aIz = false;
  this.aIA = null;
  this.aIB = false;
  this.aIC = null;
  this.aID = false;
  $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ = this;
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeBigDecimal__$init$__V(this);
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$.prototype = $p;
$p.aA = (function() {
  if ((!this.aIF)) {
    this.aIE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$1(this);
    this.aIF = true;
  }
  return this.aIE;
});
$p.o3 = (function() {
  if ((!this.aIH)) {
    this.aIG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeBigDecimal$$anon$3(this);
    this.aIH = true;
  }
  return this.aIG;
});
$p.iq = (function() {
  if ((!this.aIz)) {
    this.aIy = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aIz = true;
  }
  return this.aIy;
});
$p.J2 = (function(x$0) {
  this.aII = x$0;
});
$p.AK = (function() {
  if ((!this.aIB)) {
    this.aIA = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lalleycats_Empty$$anon$1(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction0((() => {
      var $x_1 = $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$();
      var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_package$().ox();
      var e$proxy11 = $x_1.iu(this$1.pp(0, this$1.hX));
      if ((e$proxy11 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left)) {
        throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IllegalStateException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IllegalStateException(), (("Expected Right, got Left(" + e$proxy11.bj) + ")"));
      }
      if ((e$proxy11 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Right)) {
        return e$proxy11.aI;
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(e$proxy11);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lalleycats_Empty$());
    this.aIB = true;
  }
  return this.aIA;
});
$p.brX = (function() {
  if ((!this.aID)) {
    this.aIC = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Discount";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aID = true;
  }
  return this.aIC;
});
$p.bog = (function(v) {
  $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$();
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_math_BigDecimal$();
  return v.adA(this$1.pp(100, this$1.hX));
});
$p.bDS = (function(v) {
  var this$1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_package$().ox();
  return this$1.pp(1, this$1.hX).apG(this.bog(v));
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$, "app.data.data_point_types$package$Discount$", ({
  FE: 1,
  B: 1,
  C: 1,
  cz: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Discount$ };
//# sourceMappingURL=app.data.data_point_types$package$-Discount$.js.map
